import { TabNames } from "constant/tabNames";

const Tabs: string[] = [TabNames.Recordings, TabNames.Info];
function PPVRecordingsTab({ selectedTab, setSelectedTab }: any) {
  return (
    <div className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] p-1 backdrop-blur-md">
      {Tabs.map((tab: string, i: number) => (
        <p
          className={`cursor-pointer rounded-full px-4 py-1.5 text-[13px] font-semibold transition-all duration-300 ${
            selectedTab === tab
              ? "bg-[#f30543] text-white shadow-[0_4px_14px_rgba(243,5,67,0.35)]"
              : "text-white/60 hover:text-white/90"
          }`}
          key={i}
          onClick={() => setSelectedTab(tab)}
        >
          {tab}
        </p>
      ))}
    </div>
  );
}

export default PPVRecordingsTab;
